<template>
    <div class="pt-1">
        <app-input
                type="checkbox"
                @changed="setActivityStatusDone"
                :list="index"
                v-model="checkboxValue"
        />
    </div>
</template>

<script>
    import { FormMixin } from "@core/mixins/form/FormMixin";
    import { api } from "@app/Helpers/api";
    import { collect } from "@app/Helpers/Collection";

    export default {
        name: "ActivityDone",
        mixins: [FormMixin],
        props: {
            tableId: String,
        },
        data() {
            return {
                formData: this.$attrs["row-data"],
                addEditData: {},
                checkboxValue: [],
                index: [{id: this.$attrs["row-data"].id, value: "",disabled:false}],
            };
        },
        mounted(){
            api
                .route("crm/statuses")
                .params({name: "status_done", type: "activity"})
                .get()
                .then((res) => {
                    this.addEditData.status_id = collect(res).first().id;
                    this.checkboxValue = this.formData.status_id == collect(res).first().id ? [this.formData.id] : [];
                    this.index[0].disabled = this.checkboxValue.length > 0 ? true:false;
                    if (!this.$can('update_activities') || !this.$can('done_activities')) {
                        this.index[0].disabled = true;
                    }
                });
        },
        methods: {


            setActivityStatusDone() {
                //title is required for update request
                this.addEditData.title = this.formData.title;
                this.addEditData.contextable_type = this.formData.contextable_type;
                this.addEditData.contextable_id = this.formData.contextable_id;

                // status_id should be '5' as our statuses table
                this.axiosPut({
                    url: `crm/activities/${this.formData.id}`,
                    data: this.addEditData,
                }).then((response) => {
                    this.$toastr.s(response.data.message);
                    this.$hub.$emit("reload-" + "activity-modal");
                });
            },
        },
    };
</script>